import { useLocale } from "@/i18n/LocaleProvider";
import { useState } from "react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { CornerDownRight } from "lucide-react";

export const PromptsAddInput = ({
  handlePromptsAdd,
  setPromptError,
}: {
  setPromptError: (e: string) => void;
  handlePromptsAdd: (p: string) => void;
}) => {
  const { t } = useLocale();
  const [prompt, setPrompt] = useState("");
  return (
    <div className="relative group flex items-start group -mt-[6px]">
      <Input
        autoComplete="off"
        placeholder={t("legacy.enter.your.own.prompt.siimm8")}
        value={prompt}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            if (!prompt.trim()) return;
            handlePromptsAdd(prompt);
            setPrompt("");
          }
        }}
        onChange={(e) => {
          if (e.target.value.length <= 350) {
            setPromptError("");
            setPrompt(e.target.value);
          } else {
            setPromptError("Prompts name should be max. 350 chars");
          }
        }}
        className="placeholder:text-[#d5d5d5] focus-visible:placeholder:text-[#737373] py-3 border-0 m-0 items-center bg-white text-sm relative w-full focus-visible:border-[#E5E5E5] pr-[105px] shadow-none focus-visible:ring-0 focus-visible:ring-offset-0 ring-0 outline-none focus:ring-0 mr-1"
      />
      <div className="text-sm absolute right-[60px] bottom-[8px] text-[#d5d5d5] group-focus-within:text-[#737373]">
        {prompt.length}/350
      </div>
      <div className="flex justify-between">
        <Button
          size="sm"
          className="right-[13px] bottom-[2px] absolute has-[>svg]:px-2 has-[>svg]:py-1 flex cursor-pointer items-center color-[#0A0A0A] rounded-lg focus-visible:ring-0 group-focus-within:ring-neutral-300"
          variant="outline"
          onClick={(e) => {
            e.preventDefault();
            handlePromptsAdd(prompt);
            setPrompt("");
          }}
        >
          <CornerDownRight size={16}></CornerDownRight>
        </Button>
      </div>
    </div>
  );
};
